import { render } from "./addexam.vue?vue&type=template&id=3e25dfe1&scoped=true"
import script from "./addexam.vue?vue&type=script&lang=js"
export * from "./addexam.vue?vue&type=script&lang=js"

import "./addexam.vue?vue&type=style&index=0&id=3e25dfe1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e25dfe1"]])

export default __exports__